import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _5d708a2b = () => interopDefault(import('../../../pages/auth/index.vue' /* webpackChunkName: "pages/auth/index" */))
const _1e58ddc0 = () => interopDefault(import('../../../pages/auth/index/lost-password.vue' /* webpackChunkName: "pages/auth/index/lost-password" */))
const _fb314094 = () => interopDefault(import('../../../pages/auth/index/signin.vue' /* webpackChunkName: "pages/auth/index/signin" */))
const _51d49ee2 = () => interopDefault(import('../../../pages/auth/index/reset-password/_token/index.vue' /* webpackChunkName: "pages/auth/index/reset-password/_token/index" */))
const _6ffb806c = () => interopDefault(import('../../../pages/auth/index/welcome/_id/index.vue' /* webpackChunkName: "pages/auth/index/welcome/_id/index" */))
const _1b81f9c0 = () => interopDefault(import('../../../pages/cart.vue' /* webpackChunkName: "pages/cart" */))
const _08095e46 = () => interopDefault(import('../../../pages/checkout.vue' /* webpackChunkName: "pages/checkout" */))
const _67901cce = () => interopDefault(import('../../../pages/companies/index.vue' /* webpackChunkName: "pages/companies/index" */))
const _19f3db70 = () => interopDefault(import('../../../pages/delivery-costs/index.vue' /* webpackChunkName: "pages/delivery-costs/index" */))
const _4eff72fe = () => interopDefault(import('../../../pages/docs/index.vue' /* webpackChunkName: "pages/docs/index" */))
const _31c6e158 = () => interopDefault(import('../../../pages/headquarter-addresses/index.vue' /* webpackChunkName: "pages/headquarter-addresses/index" */))
const _a4d719d8 = () => interopDefault(import('../../../pages/importers/index.vue' /* webpackChunkName: "pages/importers/index" */))
const _4dd8a6a1 = () => interopDefault(import('../../../pages/imports/index.vue' /* webpackChunkName: "pages/imports/index" */))
const _be23a5b0 = () => interopDefault(import('../../../pages/orders/index.vue' /* webpackChunkName: "pages/orders/index" */))
const _2f50cb2f = () => interopDefault(import('../../../pages/orders-history/index.vue' /* webpackChunkName: "pages/orders-history/index" */))
const _f557e232 = () => interopDefault(import('../../../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _c3315c9e = () => interopDefault(import('../../../pages/roles-and-permissions/index.vue' /* webpackChunkName: "pages/roles-and-permissions/index" */))
const _1d047e8a = () => interopDefault(import('../../../pages/users/index.vue' /* webpackChunkName: "pages/users/index" */))
const _039e60c8 = () => interopDefault(import('../../../pages/companies/new.vue' /* webpackChunkName: "pages/companies/new" */))
const _1e57cebe = () => interopDefault(import('../../../pages/delivery-costs/new.vue' /* webpackChunkName: "pages/delivery-costs/new" */))
const _63c1ff62 = () => interopDefault(import('../../../pages/importers/new.vue' /* webpackChunkName: "pages/importers/new" */))
const _6a6cf934 = () => interopDefault(import('../../../pages/roles-and-permissions/permissions/index.vue' /* webpackChunkName: "pages/roles-and-permissions/permissions/index" */))
const _0b174b9f = () => interopDefault(import('../../../pages/roles-and-permissions/roles/index.vue' /* webpackChunkName: "pages/roles-and-permissions/roles/index" */))
const _f5beea6e = () => interopDefault(import('../../../pages/users/new.vue' /* webpackChunkName: "pages/users/new" */))
const _457a0798 = () => interopDefault(import('../../../pages/roles-and-permissions/permissions/new.vue' /* webpackChunkName: "pages/roles-and-permissions/permissions/new" */))
const _64a77ead = () => interopDefault(import('../../../pages/roles-and-permissions/roles/new.vue' /* webpackChunkName: "pages/roles-and-permissions/roles/new" */))
const _1e73095e = () => interopDefault(import('../../../pages/roles-and-permissions/permissions/_id/index.vue' /* webpackChunkName: "pages/roles-and-permissions/permissions/_id/index" */))
const _48137f0a = () => interopDefault(import('../../../pages/roles-and-permissions/roles/_id/index.vue' /* webpackChunkName: "pages/roles-and-permissions/roles/_id/index" */))
const _2b0a0a94 = () => interopDefault(import('../../../pages/companies/_id.vue' /* webpackChunkName: "pages/companies/_id" */))
const _2c5220b9 = () => interopDefault(import('../../../pages/companies/_id/index.vue' /* webpackChunkName: "pages/companies/_id/index" */))
const _6c9bcc09 = () => interopDefault(import('../../../pages/companies/_id/addresses.vue' /* webpackChunkName: "pages/companies/_id/addresses" */))
const _4ca9afc2 = () => interopDefault(import('../../../pages/companies/_id/documents.vue' /* webpackChunkName: "pages/companies/_id/documents" */))
const _1b373c30 = () => interopDefault(import('../../../pages/companies/_id/inactive-importers.vue' /* webpackChunkName: "pages/companies/_id/inactive-importers" */))
const _ba902480 = () => interopDefault(import('../../../pages/companies/_id/members.vue' /* webpackChunkName: "pages/companies/_id/members" */))
const _58a542f5 = () => interopDefault(import('../../../pages/companies/_id/price-discounts.vue' /* webpackChunkName: "pages/companies/_id/price-discounts" */))
const _7391be5b = () => interopDefault(import('../../../pages/delivery-costs/_id/index.vue' /* webpackChunkName: "pages/delivery-costs/_id/index" */))
const _dfd43802 = () => interopDefault(import('../../../pages/importers/_id/index.vue' /* webpackChunkName: "pages/importers/_id/index" */))
const _a53a92cc = () => interopDefault(import('../../../pages/orders-history/_id/index.vue' /* webpackChunkName: "pages/orders-history/_id/index" */))
const _6d1c7413 = () => interopDefault(import('../../../pages/orders/_id/index.vue' /* webpackChunkName: "pages/orders/_id/index" */))
const _716ab5e3 = () => interopDefault(import('../../../pages/users/_id.vue' /* webpackChunkName: "pages/users/_id" */))
const _047bf3b4 = () => interopDefault(import('../../../pages/users/_id/index.vue' /* webpackChunkName: "pages/users/_id/index" */))
const _463ff092 = () => interopDefault(import('../../../pages/users/_id/permissions-and-roles.vue' /* webpackChunkName: "pages/users/_id/permissions-and-roles" */))
const _1b6d6a02 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/auth",
    component: _5d708a2b,
    name: "auth",
    children: [{
      path: "lost-password",
      component: _1e58ddc0,
      name: "auth-index-lost-password"
    }, {
      path: "signin",
      component: _fb314094,
      name: "auth-index-signin"
    }, {
      path: "reset-password/:token",
      component: _51d49ee2,
      name: "auth-index-reset-password-token"
    }, {
      path: "welcome/:id",
      component: _6ffb806c,
      name: "auth-index-welcome-id"
    }]
  }, {
    path: "/cart",
    component: _1b81f9c0,
    name: "cart"
  }, {
    path: "/checkout",
    component: _08095e46,
    name: "checkout"
  }, {
    path: "/companies",
    component: _67901cce,
    name: "companies"
  }, {
    path: "/delivery-costs",
    component: _19f3db70,
    name: "delivery-costs"
  }, {
    path: "/docs",
    component: _4eff72fe,
    name: "docs"
  }, {
    path: "/headquarter-addresses",
    component: _31c6e158,
    name: "headquarter-addresses"
  }, {
    path: "/importers",
    component: _a4d719d8,
    name: "importers"
  }, {
    path: "/imports",
    component: _4dd8a6a1,
    name: "imports"
  }, {
    path: "/orders",
    component: _be23a5b0,
    name: "orders"
  }, {
    path: "/orders-history",
    component: _2f50cb2f,
    name: "orders-history"
  }, {
    path: "/products",
    component: _f557e232,
    name: "products"
  }, {
    path: "/roles-and-permissions",
    component: _c3315c9e,
    name: "roles-and-permissions"
  }, {
    path: "/users",
    component: _1d047e8a,
    name: "users"
  }, {
    path: "/companies/new",
    component: _039e60c8,
    name: "companies-new"
  }, {
    path: "/delivery-costs/new",
    component: _1e57cebe,
    name: "delivery-costs-new"
  }, {
    path: "/importers/new",
    component: _63c1ff62,
    name: "importers-new"
  }, {
    path: "/roles-and-permissions/permissions",
    component: _6a6cf934,
    name: "roles-and-permissions-permissions"
  }, {
    path: "/roles-and-permissions/roles",
    component: _0b174b9f,
    name: "roles-and-permissions-roles"
  }, {
    path: "/users/new",
    component: _f5beea6e,
    name: "users-new"
  }, {
    path: "/roles-and-permissions/permissions/new",
    component: _457a0798,
    name: "roles-and-permissions-permissions-new"
  }, {
    path: "/roles-and-permissions/roles/new",
    component: _64a77ead,
    name: "roles-and-permissions-roles-new"
  }, {
    path: "/roles-and-permissions/permissions/:id",
    component: _1e73095e,
    name: "roles-and-permissions-permissions-id"
  }, {
    path: "/roles-and-permissions/roles/:id",
    component: _48137f0a,
    name: "roles-and-permissions-roles-id"
  }, {
    path: "/companies/:id",
    component: _2b0a0a94,
    children: [{
      path: "",
      component: _2c5220b9,
      name: "companies-id"
    }, {
      path: "addresses",
      component: _6c9bcc09,
      name: "companies-id-addresses"
    }, {
      path: "documents",
      component: _4ca9afc2,
      name: "companies-id-documents"
    }, {
      path: "inactive-importers",
      component: _1b373c30,
      name: "companies-id-inactive-importers"
    }, {
      path: "members",
      component: _ba902480,
      name: "companies-id-members"
    }, {
      path: "price-discounts",
      component: _58a542f5,
      name: "companies-id-price-discounts"
    }]
  }, {
    path: "/delivery-costs/:id",
    component: _7391be5b,
    name: "delivery-costs-id"
  }, {
    path: "/importers/:id",
    component: _dfd43802,
    name: "importers-id"
  }, {
    path: "/orders-history/:id",
    component: _a53a92cc,
    name: "orders-history-id"
  }, {
    path: "/orders/:id",
    component: _6d1c7413,
    name: "orders-id"
  }, {
    path: "/users/:id",
    component: _716ab5e3,
    children: [{
      path: "",
      component: _047bf3b4,
      name: "users-id"
    }, {
      path: "permissions-and-roles",
      component: _463ff092,
      name: "users-id-permissions-and-roles"
    }]
  }, {
    path: "/",
    component: _1b6d6a02,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
